import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PreferenceService } from '../../services/preference.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'app-email-received',
  templateUrl: './email-received.component.html',
  styleUrls: ['./email-received.component.scss']
})
export class EmailReceivedComponent implements OnInit {

  code: string;
  demoId: string;
  message: string;
  title: any;
  text: any;
  loginPage = 'https://orbitax.com';
  isFailed: boolean;
  mailResponse: any;
  constructor(private preferenceSerivce: PreferenceService,
    private fuseSplashScreenService: FuseSplashScreenService,
  ) { }

  ngOnInit(): void {
    if (environment.dynamicsettings['DashboardUrl']) {
      this.loginPage = environment.dynamicsettings['DashboardUrl'];
      console.log('LogIn Url found - ' + this.loginPage);
    } else {
      console.log('LogIn Url Not found from Configuration');
      console.log(environment.dynamicsettings['DashboardUrl']);
    }
    this.code = this.getUrlParam('code');
    this.demoId = this.getUrlParam('demoId');
    console.log(this.code);
    if (this.code) {
      let EmailUrl: string;
      if (this.demoId) {
        EmailUrl = `${environment.dynamicsettings['PlatformApi']}MailReceived/Confirm?code=${this.code}&demoId=${this.demoId}`;
      } else {
        EmailUrl = `${environment.dynamicsettings['PlatformApi']}MailReceived/Confirm?code=${this.code}`;
      }
      this.preferenceSerivce.getMailReceivedResponse(EmailUrl).subscribe(x => {
        this.fuseSplashScreenService.hide();
        console.log(x);
        this.mailResponse = x;
      },
        error => {
          console.log(error);
          this.mailResponse = {
            isSuccess: false,
            title: 'Failed!',
            message: 'Sorry. Something is wrong.'
          };
        });
    }
  }
  getUrlParam(name): string {
    const results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || '0';
    }
  }

}
